module.exports = __webpack_public_path__ + "static/sushi-1efce8b3bfdd0604550a68057ced54df.png";